import { fromJS, List, Map, Set } from 'immutable';
import Scenario from '../../utils/models/Scenario';
import ScenarioLog from '../../utils/models/ScenarioLog';
import {
	GET_SCENARIOS,
	SCENARIOS_CHANGED,
	SELECT_SCENARIO,
	V4_SCENARIOS_LOADED,
	V4_SCENARIO_DEDUP_UPDATED,
	V4_SCENARIO_LAST_TRIGGERED_UPDATED,
	WS_DATA_SCENARIO,
	WS_DATA_SCENARIOS,
} from '../constants/scenario.constants';
import { AUTH_SUCCESS } from '../../containers/LoginPage/constants';

export const initialState = fromJS({
	data: {},
	// Separate slice so WS_DATA_SCENARIOS (V3-only) updates don't wipe V4.
	v4Scenarios: List(),
	// V4 UUIDs resolved from V3 scenario ids — selector drops these so a
	// migrated scenario doesn't render twice.
	dedupV4Uuids: Set(),
	fetched: false,
	// `fetched` above is the V3 slice only. Every fetchV4ScenariosForUserSaga
	// branch ends in V4_SCENARIOS_LOADED, so this separates empty from not-yet.
	v4Fetched: false,
	selectedScenario: null
});

export default function scenariosReducer(state: Map = initialState, action) {
	let scenarios = state.get('data');
	switch (action.type) {
		case AUTH_SUCCESS:
			return initialState;
		case GET_SCENARIOS:
			return state.set('fetched', false);
		case WS_DATA_SCENARIO:
			return state
				.setIn(['data', action.data.id], new Scenario(action.data))
				.set('fetched', true);
		case WS_DATA_SCENARIOS:
			scenarios = Map(action.data.map(d => new Scenario(d)).map(d => [d.id, d]));
			return state
				.set('data', scenarios)
				.set('fetched', true);
		case SCENARIOS_CHANGED:
			return state
				.set('data', action.scenarios)
				.set('fetched', true);
		case V4_SCENARIOS_LOADED:
			return state
				.set('v4Scenarios', List((action.scenarios || []).map(s => new Scenario(s))))
				.set('dedupV4Uuids', Set(action.dedupV4Uuids || []))
				.set('v4Fetched', true);
		case V4_SCENARIO_DEDUP_UPDATED:
			return state.set('dedupV4Uuids', Set(action.dedupV4Uuids || []));
		case V4_SCENARIO_LAST_TRIGGERED_UPDATED: {
			const v4Scenarios = state.get('v4Scenarios') || List();
			const index = v4Scenarios.findIndex(
				scenario => String(scenario?.get?.('id')) === String(action.scenarioId)
			);
			if (index < 0) return state;

			const scenario = v4Scenarios.get(index);
			const lastRun = ScenarioLog.fromLastTriggeredAt(
				action.lastTriggeredAt,
				action.scenarioId
			);
			// A triggered event must never erase or move Last run backwards when
			// concurrent detail requests finish out of order.
			if (!lastRun || (scenario.getLastRun()?.dateTime || 0) > lastRun.dateTime) {
				return state;
			}

			const v4Data = scenario.get('v4Data') || {};
			return state.setIn(
				['v4Scenarios', index],
				scenario
					.set('logs', [lastRun])
					.set('v4Data', { ...v4Data, last_triggered_at: action.lastTriggeredAt })
			);
		}
		case SELECT_SCENARIO:
			return state.set('selectedScenario', action.scenario);
		default:
			return state;
	}
}
